export function renderBuildReadSelectOptionTypeComponentTemplate(): string {
  return `export interface SelectOptionValue {
  label: string
  value: string
}`
}
